/**
 * @file index.ts
 * @description Конфигурация центрального Redux store для Task Manager приложения. Объединяет все slice'ы состояния (перечисления, меню, аутентификация, модальные окна) в единое хранилище с типизированными селекторами и dispatch функциями для управления глобальным состоянием приложения.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@reduxjs/toolkit', '@features/enums/enum-slice', './slices/menu-slice', '@features/auth/auth-slice', './slices/modals-queue-slice']
 * @related-files ['src/features/enums/enum-slice.ts', 'src/store/slices/menu-slice.ts', 'src/features/auth/auth-slice.ts', 'src/store/slices/modals-queue-slice.ts', 'src/main.tsx']
 */

import { configureStore } from '@reduxjs/toolkit';
import enumSlice from '@features/enums/enum-slice';
import menuSlice from './slices/menu-slice';
import userSlice from '@features/auth/auth-slice';
import modalsQueueSlice from './slices/modals-queue-slice';

const store = configureStore({
    reducer: {
        enumStore: enumSlice,
        menuStore: menuSlice,
        userStore: userSlice,
        modalsQueueStore: modalsQueueSlice
    }
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
